module.exports = __webpack_public_path__ + "assets/img/7329-wf.svg";